(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('GeneralController', GeneralController);

    GeneralController.$inject = ['$scope'];

    function GeneralController($scope) {
        // Initialize model
        var vm = this;

        init(null, $scope.vm.formData);
        $scope.$on('formDataReinitialized', init);

        function init(event, formData) {
            if (!$scope.vm.formData.general.outputFormat) {
                $scope.vm.formData.general.outputFormat = "AIC";
                $scope.vm.setDirty("general.outputFormat")
            }
        }
    }
})();
